import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CsvService {

  constructor() {
      // This is intentional
   }

  downloadFile(data, filename='data') {
    let csvData = this.ConvertToCSV(data, ['nombre','id_curp', 'fecha_nacimiento', 'edad_actual', 'canalizada_por','motivo_de_ingreso','fecha_ingreso','edad_ingreso','tipo_discapacidad','diagnostico_neurologico','diagnostico_motriz','condicion_relevante','tipo_de_sangre','estatus','tiempo_de_estancia','fecha_de_egreso','motivo_egreso','lugar_destino']);
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
}

ConvertToCSV(objArray, headerList) {
     let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
     let str = '';
     let row = 'No|';

     for (let index in headerList) {
         row += headerList[index] + '|';
     }
     row = row.slice(0, -1);
     str += row + '\r\n';
     for (let i = 0; i < array.length; i++) {
         let line = (i+1)+'';
         for (let index in headerList) {
            let head = headerList[index];

             line += '|' + array[i][head];
         }
         str += line + '\r\n';
     }
     return str;
 }
}
